import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CartridgeOverviewInfo } from '@markant-platform/shared/organization/model';
import { Table } from '@markant-platform/shared/table/feature';
import { CMSLanguageService, Page, TableContext } from '@markant-platform/shared/data-access';
import { Filter, mapActiveToMarkantFilter } from '@markant-platform/shared/ui-filter';
import { TableDraft, TableParamConfig } from '@markant-platform/shared/table/model';
import { distinctUntilChanged, Observable, of, switchMap, tap } from 'rxjs';
import { deepEqual, MarkantSelectOption } from '@markant-platform/shared/util-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MarkantFilterGroup } from '@markant/elements-angular';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'markant-platform-organization-bookings-table',
  templateUrl: './organization-bookings-table.component.html',
  styleUrls: ['./organization-bookings-table.component.scss'],
})
export class OrganizationBookingsTableComponent extends Table implements OnInit {
  @Input() filter: Filter<MarkantSelectOption> = {};

  @Input({ required: true }) set draft(draft: TableDraft) {
    this.tableDraft = draft;
  }

  @Input({ required: true }) loadFunction!: (tableParams: TableParamConfig) => Observable<Page<CartridgeOverviewInfo>>;
  @Input() forceUpdate: Observable<boolean> = of(true);

  @Output() updateFilterValues: EventEmitter<void> = new EventEmitter();

  @ViewChild(MarkantFilterGroup) filterGroup!: MarkantFilterGroup;

  override preSelectedOptions = { state: ['ACTIVE'] };

  constructor(
    private readonly cmsLanguageService: CMSLanguageService,
    private readonly translocoService: TranslocoService
  ) {
    super(TableContext.ORGANIZATION_BOOKINGS_OVERVIEW);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.cmsLanguageService.activeCMSLanguage$
      .pipe(
        switchMap(() => this.forceUpdate),
        switchMap(() => this.tableParams$.pipe(distinctUntilChanged(deepEqual))),
        tap((tableParams: TableParamConfig) => {
          const { sort } = tableParams;

          this.tableDraft.sortStartColumnId = sort?.sortField;
          this.tableDraft.sortStartDirection = sort?.sortOrder;

          this.isLoading$.next(true);
        }),
        switchMap(tableParams => this.loadFunction(tableParams)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(({ result, totalCount }) => {
        this.totalCount = totalCount;
        this.updateFilterValues.emit();

        setTimeout(() => {
          const activeFilters = mapActiveToMarkantFilter(
            this.tableParams$.value.activeFilter,
            this.filter,
            this.translocoService
          );
          this.filterGroup.updateActiveFilters(() => activeFilters).then();
        });

        this.reload(result);
      });
  }
}
